export default "__VITE_ASSET__4xj91dvdo2GdjX4xzSZRRg__"